import React from 'react';
import { LM_TOKENS } from '../../live-monitor/config';
import type { LiveMonitorFilterCounts, LiveMonitorFilterId } from '../../live-monitor/types';

const FILTER_OPTIONS: {
  id: LiveMonitorFilterId;
  label: string;
  needsDot?: boolean;
}[] = [
  { id: 'all', label: 'All' },
  { id: 'needs', label: 'Needs attention', needsDot: true },
  { id: 'inbound', label: 'Inbound' },
  { id: 'outbound-patient', label: 'Outbound · patient' },
  { id: 'outbound-insurance', label: 'Outbound · insurance' },
];

export interface LiveMonitorFilterProps {
  value: LiveMonitorFilterId;
  onChange: (value: LiveMonitorFilterId) => void;
  counts: LiveMonitorFilterCounts;
}

export function LiveMonitorFilter({ value, onChange, counts }: LiveMonitorFilterProps) {
  const countFor = (id: LiveMonitorFilterId) => {
    switch (id) {
      case 'all':
        return counts.all;
      case 'needs':
        return counts.needs;
      case 'inbound':
        return counts.inbound;
      case 'outbound-patient':
        return counts.outboundPatient;
      case 'outbound-insurance':
        return counts.outboundInsurance;
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      {FILTER_OPTIONS.map((opt) => {
        const isActive = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            onClick={() => onChange(opt.id)}
            className="inline-flex h-[34px] cursor-pointer items-center gap-[7px] rounded-full px-[13px] text-[13px] font-medium tracking-[-0.005em] transition-all duration-[140ms]"
            style={{
              background: isActive ? 'var(--cream-1)' : 'transparent',
              border: `1px solid ${isActive ? 'rgba(28, 24, 18, 0.24)' : 'var(--cream-2)'}`,
              color: isActive ? 'var(--ink-0)' : 'var(--ink-1)',
              fontWeight: isActive ? 600 : 500,
              boxShadow: isActive ? LM_TOKENS.shadowXs : 'none',
            }}
          >
            {opt.needsDot && (
              <span
                className="lm-breathe rounded-full"
                style={{ width: 6, height: 6, background: LM_TOKENS.negative }}
              />
            )}
            <span>{opt.label}</span>
            <span
              className="lm-mono rounded-[5px] px-1.5 py-px text-[10.5px] font-semibold"
              style={{
                background: isActive ? 'var(--surface-mute)' : 'var(--cream-0)',
                color: isActive ? 'var(--ink-1)' : LM_TOKENS.ink4,
              }}
            >
              {countFor(opt.id)}
            </span>
          </button>
        );
      })}
    </div>
  );
}
